<div class="page-container" [class.chat-open]="isChatOpen">
  <div class="main-content">
    <div class="content">
      <div class="form-cont">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-5">
            <app-stickybar></app-stickybar>
          </div>

          <div class="col-xl-9 col-lg-8 col-md-7">
            <div class="card medi-consult-container">
              <div class="card-body pt-0">
                <div class="tab-content pt-0">
                  <div
                    id="pat_medicalrecords"
                    class="tab-pane fade show active"
                  >
                    <div class="tabs-container">
                      <h1>Telemedicine Consultations</h1>
                      <a
                        class="add-new-btn button_class"
                        [class.disabled]="tableData.length === 1"
                        (click)="checkEligibility()"
                        >Book Consultation</a
                      >
                    </div>
                    <div
                      class="card card-table mb-0 mt-0 booking-details"
                      style="
                        min-height: auto !important;
                        background-color: #edf5fb !important;
                      "
                    >
                      <div class="card-body">
                        <app-ag-grid-table
                          [subTitle]="'Booking Details'"
                          #agGridRef
                          [rowData]="rowData"
                          [parentContext]="this"
                          [currentRowSelectedIndex]="currentRowSelectedIndex"
                          [columnDefs]="colDefs"
                          [paginationPageSize]="paginationPageSize"
                          (gridReady)="onGridReady($event)"
                          (reloadTable)="reload($event)"
                        ></app-ag-grid-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="chat-sidebar" *ngIf="isChatOpen">
    <div class="chat-header">
      <div class="chat-user">
        <div class="avatar">
          {{ chatInitials }}
        </div>

        <div class="user-info">
          <div class="name">
            {{
              (chatData?.doctor_first_name || "") +
                " " +
                (chatData?.doctor_last_name || "") || "Doctor"
            }}
          </div>
          <div class="status"><span class="dot"></span> Online</div>
        </div>
      </div>

      <div class="chat-actions">
        <button
          class="icon-btn"
          (click)="startAudioCall()"
          [disabled]="chatData?.tc_plan_type !== 'Consult Now'"
        >
          <i class="fas fa-phone"></i>
        </button>

        <button
          class="icon-btn"
          (click)="startVideoCallFromChat()"
          [disabled]="chatData?.tc_plan_type !== 'Consult Now'"
        >
          <i class="fas fa-video"></i>
        </button>

        <button class="icon-btn" (click)="closeChatPanel()">✖</button>
      </div>
    </div>

    <div class="booking-bar">
      <div>
        <strong>Booking #{{ chatData?.tc_booking_id }}</strong>
        <div class="time">
          {{ chatData?.booking_date | date: "dd MMM yyyy" }} •
          {{
            chatData?.tc_plan_type == "Consult Now"
              ? (chatData.createdAt | date: "hh:mm a")
              : chatData.booking_time
          }}
        </div>
      </div>

      <div class="status">
        {{ chatData?.tc_booking_status }}
      </div>
    </div>

    <!-- CHAT BODY -->
    <div class="chat-body">
      <div *ngIf="chatMessages?.length === 0" class="no-messages">
        No messages yet
      </div>

      <div
        *ngFor="let msg of chatMessages"
        class="message-row"
        [ngClass]="{ me: msg.from === 'me', other: msg.from !== 'me' }"
      >
        <div class="avatar-small" *ngIf="msg.from !== 'me'">DR</div>

        <div class="bubble">
          <!-- Image -->
          <ng-container *ngIf="msg.chatType === 'image' && msg.fileUrl; else nonImage">
            <img
              [src]="msg.fileUrl"
              class="chat-img"
              [alt]="msg.fileName"
              (click)="openFile(msg.fileUrl)"
            />
          </ng-container>

          <!-- PDF / other file -->
          <ng-template #nonImage>
            <ng-container *ngIf="msg.fileUrl; else textOnly">
              <div class="chat-file-row">
                <span class="chat-file-icon">
                  {{ msg.chatType === 'pdf' ? '📄' : '📎' }}
                </span>
                <a [href]="msg.fileUrl" target="_blank" rel="noopener noreferrer" class="chat-file-link">
                  {{ msg.fileName || 'Download file' }}
                </a>
              </div>
            </ng-container>
          </ng-template>

          <!-- Plain text -->
          <ng-template #textOnly>
            <div class="text">{{ msg.message }}</div>
          </ng-template>

          <div class="time">{{ msg.time }}</div>
        </div>
      </div>
    </div>

    <div class="appointment-card">
      <!-- Title -->
      <div class="title">{{ uiState.title }}</div>

      <ng-container *ngIf="!uiState.canRate">
        <button
          class="action-btn"
          (click)="reschedule(chatData)"
          *ngIf="uiState.canReschedule"
        >
          🔁 Reschedule Appointment
        </button>

        <button
          class="action-btn cancel"
          (click)="cancelAppointment()"
          *ngIf="uiState.canCancel"
        >
          ✖ Cancel Appointment
        </button>

        <button
          class="action-btn reminder"
          (click)="setReminder()"
          *ngIf="uiState.canSetReminder"
        >
          🔔 Set Reminder
        </button>
      </ng-container>

      <ng-container *ngIf="uiState.canRate">
        <button class="action-btn reminder" (click)="rateExperience()">
          ⭐ Rate your Experience
        </button>

        <button class="action-btn reminder" (click)="viewSummary()">
          📄 Consultation Summary
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Summary Modal -->
<div class="payment_summary_modal" *ngIf="proceedToPay">
  <div class="summary-box pay-summary">
    <button class="close-btn cross" (click)="this.proceedToPay = false">
      ×
    </button>
    <h2>Summary</h2>
    <p>
      <strong>Name:</strong>
      {{
        paymentStatus?.user_first_name + " " + paymentStatus?.user_last_name ||
          "Not available"
      }}
    </p>
    <p>
      <strong>Number:</strong> +263 {{ paymentStatus?.phone_number || "N/A" }}
    </p>
    <p>
      <strong>Date:</strong>
      {{
        paymentStatus?.booking_date
          ? (paymentStatus?.booking_date | date: "dd/MM/yy")
          : "Not selected"
      }}
    </p>
    <p>
      <strong>Slot:</strong>
      {{ paymentStatus?.booking_time ? paymentStatus.booking_time : "Not set" }}
    </p>
    <p>
      <strong>Reason for Consultation:</strong>
      {{
        paymentStatus?.reason_for_consultation &&
        paymentStatus?.reason_for_consultation !== "USSD" &&
        paymentStatus?.reason_for_consultation !== "IVR"
          ? paymentStatus?.reason_for_consultation
          : "N/A"
      }}
    </p>
    <p>
      <strong>Consultation Charges:</strong>
      {{ paymentStatus?.currency || "N/A" }}
      {{ paymentStatus?.a_la_carte_price || "N/A" }}
    </p>

    <div class="button-group summary-btns">
      <button class="btn back" (click)="closeProceedPayment()">Back</button>
      <button class="btn confirm button_class" (click)="onCheckEl()">
        {{
          is_al_carte == false || completeTelemedSub
            ? "Confirm & Pay"
            : "Confirm"
        }}
      </button>
    </div>
  </div>
</div>

<!-- Slot Modal -->
<div class="payment_summary_modal" *ngIf="slotUnavailable">
  <div class="summary-box pay-summary">
    <div class="slot-img-container">
      <img
        src="../../../../assets/img/unavailable-slot.webp"
        class="slot-icon"
        alt="unavailable"
      />
    </div>

    <button class="close-btn cross" (click)="this.slotUnavailable = false">
      ×
    </button>
    <div class="slot-unavailable">Slot Unavailable</div>

    <p>
      The consultation slot you selected is no longer available as it has
      already been booked by other patient. Please choose a different slot to
      continue with your booking.
    </p>
    <div class="button-okay summary-btns">
      <button class="btn confirm button_class" (click)="closeProceedPayment()">
        Okay
      </button>
    </div>
  </div>
</div>

<div class="payment_summary_modal" *ngIf="enterEcocashPIn">
  <div class="ecocash-pin-container" [formGroup]="pinForm">
    <h3>
      Current Ecocash Number: <b>{{ billingNumber }}</b>
    </h3>
    <h2>Please enter your EcoCash pin:</h2>
    <div class="pin-inputs">
      <input
        #pinInput
        type="text"
        maxlength="1"
        *ngFor="let control of [0, 1, 2, 3]; let i = index"
        [formControlName]="'pin' + i"
        (input)="onInput(i, $event)"
        (keypress)="allowOnlyDigits($event)"
        (keydown)="onKeyDown(i, $event)"
      />

      <button type="button" class="eye-btn" (click)="togglePinVisibility()">
        <i class="fa" [ngClass]="showPin ? 'fa-eye-slash' : 'fa-eye'"></i>
      </button>
    </div>
    <div class="error-message" *ngIf="pinForm.invalid && pinForm.touched">
      Please enter all 4 digits of your EcoCash PIN.
    </div>
    <div class="button-group">
      <button class="btn back" (click)="closeEcoCashPin()">Close</button>
      <button class="confirm-btn button_class" (click)="onSubmit()">
        Confirm
      </button>
    </div>
  </div>
</div>

<div class="error-box" *ngIf="IncorrectPin">
  <div class="summary-box error-pin-box">
    <img
      src="../../../../assets/icons\notification-icons\warning.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Incorrect PIN</h2>
    <p>Please enter valid pin, you have {{ attemptsLeft }} chances left</p>
    <button (click)="proceedToPays()" class="proceed-btn">
      Proceed to pay
    </button>
  </div>
</div>

<div class="error-box" *ngIf="ErrorPin && responseStatusCode !== '99033'">
  <div class="summary-box error-pin-box">
    <img
      src="../../../../assets/icons\notification-icons\warning.png"
      alt="Error Icon"
      class="error-icon-p-failed"
    />
    <h2>Payment Failed</h2>
    <p>{{ paymentMessage }}</p>
    <a (click)="moveToHomeScreen()" class="retry-link button_class"
      ><span class="text-white class">Tap here</span> to try again</a
    >
  </div>
</div>

<div *ngIf="ErrorPin && responseStatusCode === '99033'">
  <app-add-alternate-number
    (triggerMoveToHome)="moveToHomeScreen()"
    (triggerOtpSuccess)="proceedToPays($event)"
  ></app-add-alternate-number>
</div>

<div class="error-box" *ngIf="blockAccount">
  <div class="summary-box error-pin-box">
    <img
      src="../../../../assets/icons\notification-icons\warning.png"
      alt="Error Icon"
      class="incorrect-pin"
    />
    <h2>Payment Failed</h2>
    <p>
      The PIN you have entered is Incorrect. On the next unsuccessful attempt,
      you will be blocked.
    </p>
    <a (click)="moveToHomeScreen()" class="retry-link button_class"
      ><span class="text-white">Tap here</span> to try again</a
    >
  </div>
</div>

<div class="payment_success_modal" *ngIf="bookingConfirmed === 'success'">
  <div class="success-box">
    <img
      src="../../../../assets/img/check-mark-removebg-preview.png"
      alt="Success"
      class="success-icon"
    />
    <h2>Payment Successful!!</h2>
    <p>Your booking is confirmed, our doctor will contact you shortly!!</p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="payment_success_modal" *ngIf="bookingConfirmed === 'failed'">
  <div class="summary-box error-pin-box">
    <img
      src="../../../../assets/icons\notification-icons\warning.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Payment Failed</h2>
    <p>
      {{ remark }}
    </p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="payment_success_modal" *ngIf="bookingConfirmed === 'progress'">
  <div class="success-box">
    <img
      src="../../../../assets/img/check-mark-removebg-preview.png"
      alt="Success"
      class="success-icon"
    />
    <h2>Payment In Progress</h2>
    <p>Your payment is being processed. Please wait a few moments.</p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="error-box" *ngIf="tryLater">
  <div class="summary-box error-pin-box">
    <img
      src="../../../../assets/icons\notification-icons\warning.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Payment Failed!!</h2>
    <p>
      Please try again later, sorry for the inconvenience. Now you have
      {{ attemptsLeft }} chances left
    </p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="custom-modal-backdrop" id="popupModal" *ngIf="showApologies">
  <div class="custom-modal">
    <button class="close-btn" (click)="showApologies = false">×</button>
    <h2>⏳ Hold On! You're Almost There</h2>
    <p>
      To unlock this service, you need to be with us for at least 3 months.<br />
      But good news! You don’t have to wait — enjoy this service now via
      A-la-carte for a small fee.
    </p>
    <p class="highlight">👉 Tap Continue to access it instantly.</p>
    <button class="continue-btn button_class" (click)="openForm()">
      Continue
    </button>
  </div>
</div>

<div class="custom-modal-backdrop" id="popupModal" *ngIf="reachedSubTelemed">
  <div class="custom-modal">
    <button class="close-btn" (click)="reachedSubTelemed = false">×</button>
    <h2>⏳ Hold On! You're Almost There</h2>
    <p>
      You have already exhausted your 12 consultations for this year under your
      subscription plan. To continue, please proceed with an A-la-carte
      consultation.
    </p>
    <button class="continue-btn button_class" (click)="initSubsForm()">
      Continue
    </button>
  </div>
</div>

<div class="no-plan-popup-backdrop" *ngIf="showNoPlanPopup">
  <div class="no-plan-popup-modal">
    <button class="no-plan-popup-close-btn" (click)="showNoPlanPopup = false">
      ×
    </button>
    <h2>🔒 No Plan? No Problem!</h2>
    <p>
      You're not subscribed to any plan, but you can still book this service via
      A-la-carte at a nominal cost.
    </p>
    <div class="no-plan-popup-button-group">
      <button
        class="no-plan-popup-action-btn button_class"
        (click)="openForm()"
      >
        Book via A-la-carte
      </button>
      <button
        class="no-plan-popup-action-btn button_class"
        (click)="upgradePlan()"
      >
        Subscription plans
      </button>
    </div>
  </div>
</div>

<div class="exclusive-popup-backdrop" *ngIf="showExclusivePopup">
  <div class="exclusive-popup-modal">
    <button
      class="exclusive-popup-close-btn"
      (click)="showExclusivePopup = false"
    >
      ×
    </button>
    <h2>🚫 Exclusive Service</h2>
    <p>This service is available under a premium plan.<br />You can:</p>
    <ul class="exclusive-popup-list">
      <li>⚡ Upgrade to a premium plan for full access</li>
      <li>💳 Use A-la-carte and pay only for this service</li>
    </ul>
    <div class="exclusive-popup-button-group">
      <button
        class="exclusive-popup-action-btn button_class"
        (click)="upgradePlan()"
      >
        Upgrade Plan
      </button>
      <button
        class="exclusive-popup-action-btn button_class"
        (click)="openForm()"
      >
        Use A-la-carte
      </button>
    </div>
  </div>
</div>

<!-- Symptoms Modal -->
<div class="symptom-popup" *ngIf="showSymptoms">
  <div class="popup-header">
    <h3>Diagnosis and Symptoms</h3>
  </div>

  <div class="popup-body">
    <div class="symptom-box">
      <p>{{ viewPrescriptionfile?.symptoms }}</p>
    </div>
  </div>

  <div class="popup-footer">
    <button class="btn back" (click)="this.showSymptoms = false">Close</button>
    <button
      class="btn confirm button_class"
      (click)="viewPrescription(viewPrescriptionfile)"
    >
      View Prescription
    </button>
  </div>
</div>

<div class="popup-overlay-celebrate" *ngIf="showCongratePopup">
  <div class="popup-card-celebrate">
    <button class="close-btn" (click)="showCongratePopup = false">×</button>

    <div class="popup-content-celebrate">
      <div class="illustration-row">
        <img
          src="../../../../assets/img/lap-girl.webp"
          alt="Woman"
          class="illustration-img-girl"
        />
        <img
          src="../../../../assets/img/celebration.webp"
          class="congrate-img"
          alt="Celebration"
        />
        <img
          src="../../../../assets/img/mob-doctor.webp"
          alt="Doctor"
          class="illustration-img-boy"
        />
      </div>

      <h2 class="congrate">Congratulations!</h2>
      <h2 class="congrate">3 Months Completed</h2>
      <p class="eligibility-text">
        You are now eligible for 12 free consultations per year.
      </p>
      <p class="info-text">Connect with trusted doctors anytime.</p>

      <button
        class="continue-btn button_class continue"
        (click)="initSubsForm()"
      >
        Continue
      </button>
    </div>
  </div>
</div>

<a
  id="openAddTeleModal"
  class="d-none"
  data-bs-toggle="modal"
  data-bs-target="#add_tele"
></a>
<a
  id="prescriptionPdfModal"
  class="d-none"
  data-bs-toggle="modal"
  data-bs-target="#prescription_pdf"
></a>

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="skyblue"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="spinner-text">Please wait...</p>
</ngx-spinner>
